import { Typography } from '@mui/material';
import { ELinks } from '@sharedInterfaces/globalEnums';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import InnerLayout from '@src/App/Components/Core/Layouts/InnerLayout/InnerLayout';
import { createLoginUrl } from '@src/App/Utils/authUrlGenerator';
import { isLoggedIn } from '@store/reducer/clientReducer';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

/**
 * Represents the LoginPage component.
 *
 * @returns {JSX.Element} The rendered LoginPage component.
 */
function LoginPage() {
    const lang = useSelector((state: AppState) => state.employee.language);
    const startPage = useSelector((state: AppState) => state.employeeSettings.startPage);
    const langStrings = getLanguageTexts(lang).loggedin;

    const loggedIn = useSelector((state: AppState) => isLoggedIn(state.client.secret));
    const loginUrl = createLoginUrl(window.location.hostname);
    if (loggedIn) {
        location.pathname = ELinks[startPage];
    } else {
        location.href = loginUrl;
    }

    return (
        <InnerLayout title={langStrings.title}>
            <NavLink to={loginUrl}>
                <Typography variant="body1">{langStrings.redirect}</Typography>
            </NavLink>

            <NavLink to={loginUrl}>Login</NavLink>
        </InnerLayout>
    );
}

export default LoginPage;
